import React, { FC } from 'react';
import { ResultsProps } from '../types';

export const ResultsError: FC<ResultsProps> = ({ id }) => {
  const testId = `${id}ResultsError`;

  return (
    <div className="resultsError" data-testid={testId} data-cy={testId}>
      <div className="labelResultsError">
        An error occurred retrieving your search results, please try again.
      </div>
    </div>
  );
};
